import { useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DataTable from "../components/DataTable";
import "../styles/patient.css";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export default function Patient() {
  const navigate = useNavigate();
  useEffect(() => {
    const checkToken = async () => {
      const token = localStorage.getItem("access_token");
      if (!token) {
        navigate("/");
        return;
      }
      try {
        await axios.get(
          `${API_BASE_URL}/api/dashboard/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } catch (err) {
        if (err.response?.status === 401) {
          alert("Session expired, please login again");
          localStorage.removeItem("access_token");
          localStorage.removeItem("refresh_token");
          localStorage.removeItem("user"); 
          navigate("/");
        }
      }
    };
    checkToken();
  }, [navigate]);
  return (
    <div className="patient-content">
      <DataTable activeToolId={0} />
  </div>
  );
}